<template>
   <form @submit.prevent="handleLogin">
      <atom-title title="Log In"/>
      <error-list
         :errors="errors.non_field"
      />
      <input-field
         type="email"
         v-model="email"
         placeholder="Email"
         :errors="errors.email"
         required
      />
      <input-field
         type="password"
         v-model="password"
         placeholder="Password"
         :errors="errors.password"
         required
      />
      <submit-btn
         label="Log in"
         loadingLabel="Logging in"
         :isLoading="isSubmittingForm"
      />
   </form>
</template>

<script>
import AtomTitle from '../../../atoms/Login/Title';
import InputField from '../../../molecules/Login/InputField';
import SubmitBtn from '../../../molecules/Login/SubmitBtn';
import ErrorList from "../../../molecules/Login/Errors";

import { mapActions,mapGetters } from "vuex";

export default {
   name: 'login-form',
   components: {
      AtomTitle,
      ErrorList,
      SubmitBtn,
      InputField,
   },
   data()
   {
      return {
         email: "",
         password: "",
         errors: {
            email: [],
            password: [],
            non_field: []
         },
         isSubmittingForm: false
      }
   },
   computed:{ 
      ...mapGetters('users', ['isManagerOrHigher']),
   },
   methods: {
      ...mapActions('users', ['logIn']),
      setErrors({email,password,detail})
      {
         this.errors.email = email ? email : [];
         this.errors.password = password ? password : []; 
         this.errors.non_field = detail ? [detail] : [];
      },
      async handleLogin()
      {
         if (this.isSubmittingForm) return;
         this.setErrors({});
         try
         {
            this.isSubmittingForm = true;
            await this.logIn({email: this.email, password: this.password});
            const nextRoute = this.isManagerOrHigher ? {name: 'admin'} : {name: 'home'}
            console.log(nextRoute);
            this.$router.push(nextRoute);
         }
         catch (error)
         {
            console.log(error)
            this.email = "";
            this.password = "";
            if (!error.response)
            {
               this.errors.non_field = ["Couldn't connect to server. (Please check internet connection)"];
            }
            else
            {
               this.setErrors(error.response.data);
            }
         }
         this.isSubmittingForm = false;
      }
   }
}
</script>

<style scoped>
form {
   text-align: center;
   margin: 5px auto;
}
</style>